<template>
  <div></div>
</template>

<script>
export default {
  name: 'EyecatchExistenceItem',
  props: {
    regulationItem: {
      type: Object,
      required: true
    }
  }
}
</script>
